// extracted by mini-css-extract-plugin
module.exports = {"link":"dist-es__Link__link"};